var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMeasure = function SvgMeasure(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.20695 18.2846C8.83582 18.6558 8.38897 18.8413 7.8664 18.8412C7.34373 18.8412 6.89687 18.6557 6.52584 18.2846L1.9597 13.7185C1.58866 13.3475 1.40315 12.9006 1.40315 12.3779C1.40305 11.8554 1.58856 11.4085 1.9597 11.0374L11.282 1.71505C11.6531 1.34392 12.1 1.1584 12.6226 1.1585C13.1452 1.1585 13.5921 1.34402 13.9631 1.71505L18.5293 6.2812C18.9003 6.65223 19.0858 7.09908 19.0858 7.62175C19.0859 8.14432 18.9004 8.59118 18.5293 8.96231L9.20695 18.2846ZM7.8664 16.9441L17.1887 7.62175L12.6226 3.05561L10.9077 4.77049L13.1908 7.05356L12.0123 8.23207L9.72918 5.949L8.55067 7.12751L10.8337 9.41058L9.65523 10.5891L7.37216 8.30603L6.19365 9.48454L8.47672 11.7676L7.29821 12.9461L5.01514 10.663L3.30025 12.3779L7.8664 16.9441Z",
    fill: "white"
  }))));
};
export { SvgMeasure as ReactComponent };
export default __webpack_public_path__ + "assets/7990e885.svg";